import { Steps } from 'antd';
import './DesignMenu.css';
import { menuItems } from './MenuItems';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';

export const DesignMenu = observer(() => {
    const { viewManager } = useMainContext();
    const currentMenuIndex = menuItems.findIndex(
        (item) => item.id === viewManager.selectedMenu,
    );

    const stepsItems = menuItems.map((menuItem, index) => {
        let status = 'wait';
        let description = '';
        let iconContent = index + 1; // Display step number

        if (index < currentMenuIndex) {
            status = 'finish';
        } else if (index === currentMenuIndex) {
            status = 'process';
            description = menuItem.label;
        } else {
            status = 'wait';
        }

        return {
            title: '',
            description: description,
            status: status,
        };
    });

    return (
        <div
            className="design_menu_block"
            style={{
                top: viewManager.selectedMenu === 2 ? '105px' : '88px',
            }}>
            <Steps
                labelPlacement="vertical"
                current={currentMenuIndex}
                items={stepsItems}
            />
        </div>
    );
});
